import { render, staticRenderFns } from "./BsPicker.vue?vue&type=template&id=0f84f30c&"
import script from "./BsPicker.vue?vue&type=script&lang=js&"
export * from "./BsPicker.vue?vue&type=script&lang=js&"
import style0 from "./BsPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports